import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchBooks from "../redux/addBooks/thunk/fetchBooks";
import BookCard from "./BookCard";

export default function BookContainer({ handleEdit }) {
  const books = useSelector((state) => state.books);
  const filter = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchBooks);
  }, [dispatch]);
  return (
    <div className="lws-bookContainer">
      {books
        .filter((book) => {
          return filter.category === "all"
            ? true
            : book.featured
            ? true
            : false;
        })
        .filter((book) => {
          return book.name.toLowerCase().includes(filter.search.toLowerCase());
        })
        .map((book) => (
          <BookCard key={book.id} book={book} handleEdit={handleEdit} />
        ))}
    </div>
  );
}
